module.exports = __webpack_public_path__ + "static/media/hat-brazil.7cd63032.png";